import { render, staticRenderFns } from "./applicantType.vue?vue&type=template&id=13a6f737&scoped=true"
import script from "./applicantType.vue?vue&type=script&lang=js"
export * from "./applicantType.vue?vue&type=script&lang=js"
import style0 from "./applicantType.vue?vue&type=style&index=0&id=13a6f737&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6f737",
  null
  
)

export default component.exports